import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

function useUserPhoto() {
  const { getAccessToken } = useAuth();
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    getAccessToken().then(token => {
      if (!token || !isMounted) {
        setPhotoUrl(null);
        setLoading(false);
        return;
      }
      fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(async response => {
          if (!isMounted) return;
          if (response.ok) {
            const blob = await response.blob();
            setPhotoUrl(URL.createObjectURL(blob));
          } else {
            setPhotoUrl(null);
          }
          setLoading(false);
        })
        .catch(() => {
          if (!isMounted) return;
          setPhotoUrl(null);
          setLoading(false);
        });
    });
    return () => { isMounted = false; };
  }, [getAccessToken]);

  return { photoUrl, loading };
}

export default useUserPhoto;